/**
 * returns the full name of an {@link entity} with a `name` and optional `description`
 *
 * @param entity an object, class, etc.
 */
export function fullName(entity: Entity): string
/**
 * returns the full name of an {@link entity} with a `name` and optional `description`
 *
 * @param entity an object, class, etc.
 */
export function fullName(entity: Entity | undefined | null): string | undefined
export function fullName(
  entity: { name: string; description?: string | null } | undefined | null
) {
  if (!entity) return undefined
  const { name, description } = entity
  if (description) return `${name} - ${description}`
  return name
}

type Entity = { name: string; description?: string | null }
